<template>
  <div class="user">
    <div>
      <div v-if="logined" class="top">
        <div>
          <img class="avatar" v-bind:src="user.user.avatar" />
        </div>
        <div class="nickname">
          {{user.user.user_nickname}}&nbsp;&nbsp;
          <br />
          编号：{{user.user.id}}
        </div>
        <div class="right"></div>
      </div>
      <div v-if="!logined" class="top" @click="goLogin">
        <div>
          <img class="avatar" src="@/assets/avatar.png" />
        </div>
        <div class="nickname">
          登录/注册
          <br />尊享推广权益
        </div>
        <div class="right">
          <div>申请分享师&nbsp;&nbsp;></div>
        </div>
      </div>
    </div>
    <div class="money">
      <div>
        <span class="m">{{userinfo.balance}}</span>
        <br />总余额（元）
      </div>
      <div>
        <span class="m">0.00</span>
        <br />冻结金额
      </div>
      <div>
        <span class="m">0.00</span>
        <br />积分(分)
      </div>
    </div>
    <div class="order">
      <div class="o_top">
        <div class="title">我的订单</div>
        <router-link
          to="/user/orderlist/-1"
          class="all"
        >查看全部&nbsp;&nbsp;></router-link>
      </div>

      <div class="o_list">
        <router-link to="/user/orderlist/1">
          <i class="iconfont icondaifukuan"></i>待付款
        </router-link>
        <router-link to="/user/orderlist/2">
          <i class="iconfont iconfahuotixing"></i>待发货
        </router-link>
        <router-link to="/user/orderlist/3">
          <i class="iconfont iconyifahuo"></i>已发货
        </router-link>
        <router-link to="/user/orderlist/4">
          <i class="iconfont iconjiaoyiwancheng"></i>交易完成
        </router-link>
      </div>
    </div>
    
    <div class="group">
      <router-link class="g_list" to="/shop/cart">
        <svg class="icon" aria-hidden="true" style="font-size:18px">
          <use xlink:href="#iconche" />
        </svg>
        <div class="title">购物车</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
        <router-link class="g_list" to="/user/addresslist">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconaddress" />
        </svg>
        <div class="title">收货地址</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
      <router-link class="g_list" to="/user/yuyue">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconyuyue" />
        </svg>
        <div class="title">预约商品</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
      <!-- <router-link class="g_list" :to="{path:'/soinin',query:{soinback:'/user'}}">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-qiandao3" />
        </svg>
        <div class="title">签到</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link> -->
      <router-link class="g_list" to="/user/money">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconqianbao2" />
        </svg>
        <div class="title">支付记录</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
      
      <router-link to="/user/tixian" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icontixian" />
        </svg>
        <div class="title">我的提现</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>

      <router-link to="/user/coupon" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconyouhuiquan1" />
        </svg>
        <div class="title">我的优惠券</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>

      <!-- <router-link to="/user/second" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icontiezi1" />
        </svg>
        <div class="title">我的闲置</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link> -->
      <router-link class="g_list" to="/user/collection">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconshoucang" />
        </svg>
        <div class="title">我的收藏</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
      <div class="g_list" v-on:click="tokd()">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconfuwu-kaidian" />
        </svg>
        <div class="title">我要开店</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </div>
      <router-link to="/user/fenxiang/index" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconfenxiang-copy1" />
        </svg>
        <div class="title">分享</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
      <router-link to="/user/jianyi" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconjianyi" />
        </svg>
        <div class="title">建议有奖</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
    </div>
    <div class="group">
      <router-link to="/article/detail/62" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconkefu" />
        </svg>
        <div class="title">客服中心</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link>
      <!-- <router-link :to="{path:'/setinfo',query:{style:'user'}}" class="g_list">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconshezhi1" />
        </svg>
        <div class="title">设置</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </router-link> -->
      <div class="last g_list" v-on:click="logout">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icontuichu" />
        </svg>
        <div class="title">退出登录</div>
        <div class="arrow">
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div style="height:120px;"></div>
    <DPtabbar active="4"></DPtabbar>
  </div>
</template>

<script>
import DPtabbar from "@/components/TabBar.vue";
export default {
  name: "userCenter",
  components: {
    DPtabbar
  },
  data() {
    return {
      logined: false,
      user: {},
      userinfo: { balance: 0.0 }
    };
  },
  methods: {
    goLogin() {
      this.$router.push({ path: "/login" });
    },
    logout() {
      localStorage.removeItem("user");
      this.logined = false;
      this.userinfo.balance = "0.00";
      this.$toast("退出登录了");
    },
    userRefresh() {
        this.$http
        .get(this.GLOBAL.API + "user/profile/userInfo?field=", {
          params: { },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.userinfo = data.data;
            this.logined=true;
          }else{
              this.$toast(data.msg);
          }
        });

    },
    tokd() {
      //开店
      if (this.user) {
        window.location.replace(
          "http://yijia.sihandbms.cn/merchant/Merchant/apply?token=" +
            this.user.token
        );
      } else {
        this.$toast("请先登录");
        this.$router.push({ path: "/login" });
      }
    }
  },

  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.userRefresh();
    }
    
  }
};
</script>

<style lang="scss" scoped>
.user {
  background: #f0eff4
    url(../../assets/user_bg.png) no-repeat
    center -60px;
  font-size: 13px;
  box-sizing: border-box;
  .top {
    position: relative;
    height: 70px;
    display: flex;
    padding: 20px 0 0 20px;
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 25px;
    }
    .nickname {
      margin: 2px 0 0 20px;
      text-align: left;
      color: #fff;
      line-height: 20px;
    }
    .right {
      flex-grow: 1;
      div {
        margin: 5px auto;
        width: 130px;
        background-color: #272727;
        border-radius: 15px;
        height: 30px;
        color: #fff;
        line-height: 30px;
        text-align: center;
      }
    }
  }
  .money {
    height: 50px;
    display: flex;
    justify-content: space-around;
    margin: 0 10px 10px 10px;
    text-align: center;
    color: #fff;
    .m {
      font-size: 18px;
    }
  }
  .order {
    margin: 0 10px 10px 10px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    .o_top {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        color: #222333;
      }
    }
    .o_list {
      margin-top: 25px;
      line-height: 30px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      .iconfont {
        display: block;
        font-size: 30px;
        color: #1baeae;
      }
    }
  }
  .group {
    margin: 0 10px 10px 10px;
    background-color: #fff;
    border-radius: 10px;
    padding: 0px 10px 5px 10px;
    text-align: left;
    .g_list {
      display: flex;
      .icon {
        width: 50px;
        height: 20px;
        vertical-align: -1px;
        fill: currentColor;
        overflow: hidden;
      }
      .title {
        width: 200px;
        color: #222333;
      }
      .arrow {
        flex-grow: 1;
        text-align: right;
        .iconfont {
          font-size: 20px;
        }
      }
      padding: 10px 0 10px 0;
      border-bottom: 1px solid #eeeeee;
      .last{
          border-bottom: none!important;
      }
    }
  }
}
</style>